<template>
  <PreviewSheet class="review-card" radius="medium">
    <div class="review-card__content flex-col gap-6">
      <div class="flex-col gap-4">
        <StarRating :rating="review.stars" />
        <PreviewTypography :text="review.comment" variant="paragraphRegular" />
      </div>
      <div class="align-center flex-row gap-3">
        <div
          :style="{ backgroundImage: `url(${review.image})` }"
          class="review-card__reviewer-image"
        ></div>
        <PreviewTypography
          :text="review.name"
          variant="titleSmall"
          color="secondary"
        />
      </div>
    </div>
  </PreviewSheet>
</template>
<script lang="ts" setup>
import StarRating from '@/components/general/StarRating.vue'
import PreviewSheet from '@/lib/builder/public/preview/PreviewSheet.vue'
import PreviewTypography from '@/lib/builder/public/preview/PreviewTypography.vue'

defineProps<{
  review: {
    comment: string
    image: string
    name: string
    stars: number
  }
}>()
</script>
<style lang="scss" scoped>
.review-card {
  box-shadow: 0 4px 24px rgba(13, 13, 13, 0.05);

  &__content {
    padding: 24px;
  }

  &__reviewer-image {
    width: 32px;
    height: 32px;
    border-radius: 16px;

    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
  }
}
</style>
